import { CircleSizes, CircleVariants, } from "./constants";
import { Contrast } from "../../../types/general.types";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { color, easing, foundation_fade, opacity, size } = ids || {};
// tiny = 20px //16 + 2 * 2 de borda
// small = 28px //24 + 2 * 2 de borda
// medium = 38px //32 + 3 * 2 de borda
// large = 72px //64 + 4 * 2 de borda
// xlarge = 138px // 128 + 5 * 2 de borda
const getCircunference = (radius) => {
    return 2 * Math.PI * radius;
};
const getDashoffset = (radius, percentage) => {
    const circunference = getCircunference(radius);
    const parts = 100 / percentage;
    return circunference - circunference / parts;
};
const circleSpinAnimation = css `
  @keyframes circleSpin {
    from {
      transform: translate(var(--spin-value), var(--spin-value)) rotate(0deg);
    }

    to {
      transform: translate(var(--spin-value), var(--spin-value)) rotate(360deg);
    }
  }
`;
const primary = css `
  stroke: ${color.action.primary.ids_color_action_primary_base};
`;
const secondary = css `
  stroke: ${color.action.secondary.ids_color_action_secondary_base};
`;
const onLight = css `
  stroke: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  stroke: ${color.contrast.ids_color_contrast_onDark};
`;
const tinyCircle = css `
  height: ${size.general.ids_size_general_20x};
  width: ${size.general.ids_size_general_20x};
`;
const tinyRing = css `
  stroke-width: ${size.general.ids_size_general_2x};
  transform: translate(
    ${size.general.ids_size_general_2x},
    ${size.general.ids_size_general_2x}
  );
`;
const tinySpin = css `
  --spin-value: ${size.general.ids_size_general_2x};
  stroke-dasharray: ${getCircunference(parseInt(size.general.ids_size_general_8x))};
  stroke-dashoffset: ${getDashoffset(parseInt(size.general.ids_size_general_8x), 25)};
  stroke-width: ${size.general.ids_size_general_2x};
  transform-origin: ${size.general.ids_size_general_8x}
    ${size.general.ids_size_general_8x};
`;
const smallCircle = css `
  height: ${size.general.ids_size_general_28x};
  width: ${size.general.ids_size_general_28x};
`;
const smallRing = css `
  stroke-width: ${size.general.ids_size_general_2x};
  transform: translate(
    ${size.general.ids_size_general_2x},
    ${size.general.ids_size_general_2x}
  );
`;
const smallSpin = css `
  --spin-value: ${size.general.ids_size_general_2x};
  stroke-dasharray: ${getCircunference(parseInt(size.general.ids_size_general_12x))};
  stroke-dashoffset: ${getDashoffset(parseInt(size.general.ids_size_general_12x), 25)};
  stroke-width: ${size.general.ids_size_general_2x};
  transform-origin: ${size.general.ids_size_general_12x}
    ${size.general.ids_size_general_12x};
`;
const mediumCircle = css `
  height: calc(
    ${size.general.ids_size_general_36x} + ${size.general.ids_size_general_2x}
  );
  width: calc(
    ${size.general.ids_size_general_36x} + ${size.general.ids_size_general_2x}
  );
`;
const mediumRing = css `
  stroke-width: ${size.general.ids_size_general_3x};
  transform: translate(
    ${size.general.ids_size_general_3x},
    ${size.general.ids_size_general_3x}
  );
`;
const mediumSpin = css `
  --spin-value: ${size.general.ids_size_general_3x};
  stroke-dasharray: ${getCircunference(parseInt(size.general.ids_size_general_16x))};
  stroke-dashoffset: ${getDashoffset(parseInt(size.general.ids_size_general_16x), 25)};
  stroke-width: ${size.general.ids_size_general_3x};
  transform-origin: ${size.general.ids_size_general_16x}
    ${size.general.ids_size_general_16x};
`;
const largeCircle = css `
  height: ${size.general.ids_size_general_72x};
  width: ${size.general.ids_size_general_72x};
`;
const largeRing = css `
  stroke-width: ${size.general.ids_size_general_4x};
  transform: translate(
    ${size.general.ids_size_general_4x},
    ${size.general.ids_size_general_4x}
  );
`;
const largeSpin = css `
  --spin-value: ${size.general.ids_size_general_4x};
  stroke-dasharray: ${getCircunference(parseInt(size.general.ids_size_general_32x))};
  stroke-dashoffset: ${getDashoffset(parseInt(size.general.ids_size_general_32x), 25)};
  stroke-width: ${size.general.ids_size_general_4x};
  transform-origin: ${size.general.ids_size_general_32x}
    ${size.general.ids_size_general_32x};
`;
const xLargeCircle = css `
  height: calc(
    ${size.general.ids_size_general_136x} + ${size.general.ids_size_general_2x}
  );
  width: calc(
    ${size.general.ids_size_general_136x} + ${size.general.ids_size_general_2x}
  );
`;
const xLargeRing = css `
  stroke-width: ${size.general.ids_size_general_5x};
  transform: translate(
    ${size.general.ids_size_general_5x},
    ${size.general.ids_size_general_5x}
  );
`;
const xLargeSpin = css `
  --spin-value: ${size.general.ids_size_general_5x};
  stroke-dasharray: ${getCircunference(parseInt(size.general.ids_size_general_64x))};
  stroke-dashoffset: ${getDashoffset(parseInt(size.general.ids_size_general_64x), 25)};
  stroke-width: ${size.general.ids_size_general_5x};
  transform-origin: ${size.general.ids_size_general_64x}
    ${size.general.ids_size_general_64x};
`;
const getCircleSizeStyle = (size, type) => {
    switch (size) {
        case CircleSizes.xlarge:
            if (type === "ring")
                return xLargeRing;
            if (type === "spin")
                return xLargeSpin;
            return xLargeCircle;
        case CircleSizes.large:
            if (type === "ring")
                return largeRing;
            if (type === "spin")
                return largeSpin;
            return largeCircle;
        case CircleSizes.medium:
            if (type === "ring")
                return mediumRing;
            if (type === "spin")
                return mediumSpin;
            return mediumCircle;
        case CircleSizes.small:
            if (type === "ring")
                return smallRing;
            if (type === "spin")
                return smallSpin;
            return smallCircle;
        case CircleSizes.tiny:
            if (type === "ring")
                return tinyRing;
            if (type === "spin")
                return tinySpin;
            return tinyCircle;
        default:
            if (type === "ring")
                return mediumRing;
            if (type === "spin")
                return mediumSpin;
            return mediumCircle;
    }
};
const getCircleVariantStyle = (variant, contrast) => {
    switch (variant) {
        case CircleVariants.primary:
            if (contrast === Contrast.light)
                return onLight;
            if (contrast === Contrast.dark)
                return onDark;
            return primary;
        case CircleVariants.secondary:
            return secondary;
        default:
            return primary;
    }
};
// transition-duration: ${ids.time.productive.fast.ids_time_productive_fast_input};
export const StyledCircle = styled.div `
  ${circleSpinAnimation}
  display: inline-block;
  position: relative;
  ${({ size }) => getCircleSizeStyle(size, "circle")}
  transition-duration: ${({ animation }) => (animation === null || animation === void 0 ? void 0 : animation.duration) ? animation.duration : 2}s;
  transition-timing-function: ${easing.expressive.inOut
    .ids_easing_expressive_standard};
  &.hide {
    opacity: ${foundation_fade.fade.fade_0};
  }
  &.show {
    opacity: ${foundation_fade.fade.fade_100};
  }
`;
export const StyledCircleSvg = styled.svg `
  ${({ size }) => getCircleSizeStyle(size, "svg")}
`;
export const StyledCircleRing = styled.circle `
  fill: transparent;
  opacity: ${opacity.ids_opacity_soft};
  stroke-width: ${size.general.ids_size_general_3x};
  ${({ variant, contrast }) => getCircleVariantStyle(variant, contrast)}
  ${({ size }) => getCircleSizeStyle(size, "ring")}
`;
export const StyledCircleSpin = styled.circle `
  animation: circleSpin 800ms linear infinite;
  fill: transparent;
  stroke-linecap: round;
  ${({ variant, contrast }) => getCircleVariantStyle(variant, contrast)}
  ${({ size }) => getCircleSizeStyle(size, "spin")}
`;
export const StyledIcon = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
//# sourceMappingURL=Circle.style.js.map